import { DayTier } from "@/types/calculators";

export const BADGE_TIER_CLASSES: Record<DayTier, string> = {
  golden: "bg-gold text-white",
  favorable: "bg-success text-white",
  personal_clash: "bg-error text-white",
  personal_routine: "bg-beige text-active border border-active/20",
};
